// eslint-disable-next-line
import React from "react"
import styled from '@emotion/styled'

// Components
import Layout from "../../components/layout";
import Masthead from "../../components/organisms/masthead"
import Footer from "../../components/organisms/footer";
import MoreResources from "../../components/molecules/more-resources";
import Header2 from "../../components/atoms/header-2";
import FormReview from "../../components/atoms/form-review";
import ExcerptsBlock from "../../components/organisms/excerpts-block";
import Paragraph1 from "../../components/atoms/paragraph-1";
import BookBlock from "../../components/organisms/book-block";
import GridThree from "../../components/organisms/grid-three";
import Review from "../../components/molecules/review";
import Header1 from "../../components/atoms/header-1";

// Images
import ImgMastheadSOTB from "../../components/images/_masthead/img-masthead-SOTB";
import ImgAccentCity from "../../components/images/_graphic/img-accent-city";
import ImgGraphicArmReachingOut from "../../components/images/_graphic/img-graphic-arm-reaching-out";
import ImgGraphicTheWorld from "../../components/images/_graphic/img-graphic-the-world";
import ImgSOTBBackP from "../../components/images/books/the-story-of-the-bible/placeholder/img-sotb-paperback-back-p";
import ImgSOTBBeveledP from "../../components/images/books/the-story-of-the-bible/placeholder/img-sotb-paperback-beveled-p";
import ImgSOTBFrontP from "../../components/images/books/the-story-of-the-bible/placeholder/img-sotb-paperback-front-p";
import ImgSOTBBeveled from "../../components/images/books/the-story-of-the-bible/img-sotb-paperback-beveled";
import ImgSOTBBack from "../../components/images/books/the-story-of-the-bible/img-sotb-paperback-back";
import ImgSOTBFront from "../../components/images/books/the-story-of-the-bible/img-sotb-paperback-front";
import SEO from "../../components/organisms/seo";

// Styles
const WrapperFill = styled.section`
  z-index: -5;
  position: absolute;
  height: 100%;
  width: 100%;
  background: #FFFFFF;
`
const Wrapper = styled.section`
  position: relative;
  background: transparent;
`
const Container = styled.section`
  position: relative;
  z-index: 10;
  max-width: 980px;
  padding: 120px 60px 300px 60px;
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: 60px 30px 150px 30px;
  }
`
const BackgroundWorld = styled.div`
  z-index: -1;  
  position: absolute;
  height: 700px;
  width: 45%;
  top: 1900px;
  left: 0;
`
const BackgroundArmsReachingOut = styled.div`
  z-index: -1;
  position: absolute;
  height: 1200px;
  width: 40%;
  top: 1600px;
  right: 0;
`
const WrapperReviews = styled.section`
  background: #525252;
  padding: 150px 0;
  margin: 0 0 60px 0;
  width: 100%;
  text-align: center;
`
const WrapperForm = styled.section`
  max-width: 800px;
  margin: 200px auto 200px auto;
  padding: 0 15px;
`

// Data
const dataDescription = [
  `<b style='color:#4C4C4C'>WHY AM I HERE?</b> If you want to know that, you have to ask another question: WHO IS GOD? And how could anyone expect to find that out? The only way is if God Himself were to tell you who He is. This book contends that God has done just that! The Bible is God's message to the world—the key that unlocks the mysteries of your life and of all human history. The answers to all the important questions people ask are woven into its story line. It is a drama of epic proportions, filled with anguish and suspense, treachery and valor. There's a dangerous villain, a rescuer who comes in disguise, apparent defeat and final triumph. This book summarizes the action of the Bible and introduces some of its characters and themes. Its purpose is to retell the story in such a compelling way that readers will be drawn to study the Bible itself and come to know its Author—and through knowing Him obtain eternal life.`,
  `Beverly Hubbard grew up in a family that loved the Bible. She had heard all the Bible stories by the time she learned to read, and after that she could read them for herself. When her parents went to Brazil as missionaries, she and her siblings were educated in mission boarding schools. Later, after getting a teaching certificate and a BA degree in English from Seattle Pacific University, she returned to Brazil to teach in a mission school. She and her husband served there together for thirteen years.`
]
const dataExcerpts = [
  {
    chapter: `Part 12`,
    title: `WHAT WAS THE FLAW IN PARADISE?`,
    scripture: `“He said to the woman, ‘Did God really say, “You must not eat from any tree in the garden”?’”  (Genesis 3:1)`,
    text: [
      `Enter the villain!  In disguise, of course.  No black cape or dark shadow over the sun to alert the unsuspecting to danger.  In her paradise home, Eve has known only perfect friendship and communication between herself and Adam and between them and God.  What reason would she have to be on guard against the fascinating creature now speaking with her?`,
      `We know that it was Satan talking through the serpent and that he was on a mission.  Ever since God had thrown him out of Heaven for planning rebellion against Him, Satan had been waiting for his chance to get back at God.  Not directly, because nobody can fight against God and win.  But God had left Himself wide open when He created these human beings with the ability to choose.  Anyone could see how much God loved them.  What a blow to God it would be if Satan could get them to turn against Him!  Satan planned his strategy and struck.`,
      `“Did God really say . . .?” he asked the woman.  That’s what Satan does.  He gets people to doubt God’s Word.  “Did God really say, ‘You must not eat from any tree in the garden’?” He gets people to think that God is cheating them.`,
      `“Oh, no,” the woman said.  “Just the tree in the middle of the garden.  We must not eat from it, or we will die.”`,
      `“You will not surely die,” the serpent said.  Now he’s calling God a liar.  He’s saying that what God said is not true.  “For God knows,” he continued, “that when you eat of it your eyes will be opened, and you will be like God, knowing good and evil.”`,
      `Suddenly paradise didn’t seem so perfect to Eve.  Something is missing, she thought, and this is what it is—to decide for myself what is good and what is evil.  What can be wrong with that?  So she took some of the fruit and ate it.  Then she gave some to Adam, who was with her, and he also ate it.`,
      `What had happened?  Satan had deceived Eve into rebelling against God by disregarding His command.  Adam was not deceived.  He knew what he was doing.  He deliberately did what God had told him not to do.  He turned away from depending on God.`,
      `Immediately they realized they were naked, and they cowered from each other in shame.  What would you do if you were suddenly exposed out in the open?  You would grasp for the nearest shred of cover.  They probably worked furiously sewing together those fig leaves, hoping to make themselves presentable.  The question is:  Did they die?`,
    ],
  },
  {
    chapter: `Part 13`,
    title: `WHY DID ADAM AND EVE HIDE FROM GOD?`,
    scripture: `“The Lord God called to the man, ‘Where are you?”  (Genesis 3:9)`,
    text: [
      `Imagine the terror Adam and Eve felt as the hour approached when God walked in the garden to talk with them.  They knew they could not face Him!  They had done what God had told them not to do, and now they knew they were naked!  Coverings of leaves sewn together could not hide them.  Would the densest thickets of the garden shield them?  Where can you run to hide from God?`,
      `One thing was for sure.  The prediction that was in doubt had happened.  God had said, “When you eat of it (the tree of the knowledge of good and evil), you will surely die.”  Satan had said, “You will not surely die.”  Which one was right?  It was clear that the relationship of intimate companionship between God and man was ended.  If death is separation, then Adam and Eve were dead.  They could not have fellowship with God.  They could only run and hide in dread and shame and despair.`,
      `They had stepped over the line from belonging to God to belonging to Satan—because you belong to whomever you obey.  The shame, the cover-up, the fear, the hiding—these were immediate signs of the transfer of ownership.  They now “knew” evil.  Furthermore, because God was the source of their life and they had been separated from Him, at that moment their bodies also began to die.  Probably Satan was rubbing his hands together in glee; he could hardly wait—because after their physical death they would be totally and irreversibly his.`,
      `And that could have been the end of the drama.  But it wasn’t.  God began to show His marvelous love and mercy.  Adam and Eve couldn’t go towards God, but God went towards them.  He loved them.  They shrank from Him, but He pursued them.  He called out to Adam, “Where are you?”  Not because He didn’t know Adam’s condition, but because He was giving Adam a chance to respond to Him.`,
      `Did Adam say, “Oh, God, I have disobeyed You.  I am so sorry.”  No. He skirted the issue.  He said, “I heard You in the garden, and I was afraid because I was naked; so I hid.”`,
      `God didn’t accept the evasion.  He dealt with the heart of the matter.  God insists on full disclosure because He is interested in full restoration.  Even though the restoration process will span thousands of years, God begins His plan of redemption.  It starts with judgment.`,
      `He said to Adam, “Who told you that you were naked?  Have you eaten from the tree that I commanded you not to eat from?”`,
      `Did Adam repent?  Did he agree with God that he had done the wrong thing?  No.  He blamed the woman—and God.  Then Eve blamed the serpent.  But remember that God loved them.  He had already planned a way to bring them back to Himself.`,
    ],
  },
  {
    chapter: `Part 14`,
    title: `HOW DOES GOD SENTENCE THE GUILTY?`,
    scripture: `“The Lord is gracious and compassionate, slow to anger and rich in love.”  (Psalm 145:8)`,
    text: [
      `What must it have been like to stand guilty before God, who like the prosecutor at a trial, interrogated first Adam and then Eve?  Neither one accepted responsibility for what had happened.  Adam blamed Eve and Eve blamed the serpent.  But God, who had seen it all, knows how to judge rightly.  He took the players one by one and laid out the consequences for what they had done.`,
      `God began with the serpent.  He cursed the serpent because it had been used by Satan.  Whatever its form had been before, now it was to writhe on the ground and become especially loathsome to the woman.  God knew that Satan had spoken through the serpent to tempt Eve.  He knew that Satan’s plan was to alienate Adam and Eve from God so that Satan would have control over them and the whole world.  It was right here that God served notice to Satan that he would lose.  Satan’s plan would fail because God Himself would shoulder the long-term consequences of Adam’s and Eve’s sin.`,
      `God made an astounding promise:  A descendant of the woman would crush the head of the serpent, and the serpent would strike his heel.  God was taking it upon Himself to deliver the human race from the control of Satan by providing a Rescuer to crush the authority and power of Satan.  However, in the process that Rescuer would be fatally struck by Satan.  This is what God said: “I will put enmity between you and the woman, and between your offspring and hers; he will crush your head, and you will strike his heel.” (Genesis 3:15)`,
      `Did Adam and Eve understand this promise?  Maybe they understood this much—that God had a plan in place to rescue them from the terrible situation they were now in and that God would win.  Notice that the Rescuer would be the woman’s offspring only, not Adam’s—our first glimpse of the truth that the Rescuer would be the child of a virgin woman.  The seeds of God’s plan are right here in the first chapters of the Bible.`,
      `God was showing His heart.  He loved Adam and Eve and the children that would be born to them.  He would not leave them in the power of Satan, whose only intent is to destroy.  He showed them grace (kindness that they did not deserve) and mercy (not giving them the punishment they did deserve) by revealing His plan to send a Rescuer who would rescue them at great cost to Himself.`,
      `Only then did God disclose the sad order of things that would be in effect as a consequence of Adam and Eve choosing to act independently from Him.  The woman, God said, will experience pain in childbirth, frustration in her marriage, and domination by her husband.  For the man (and by extension, for the woman, too) a curse on the earth will make work burdensome, life will be toilsome and sorrowful, and eventually everyone will return to the ground as dust.  This is life as we know it now.  But from this low point, God began to reveal through history His great plan to restore all things.`,
    ],
  },
]

const dataReviews = [
  {
    text: `This book was amazing for me! The Bible was written almost in a foreign language to me and did not seem to be something I could ever truly understand. But while reading The Story of The Bible it all came amazingly clear !!! and the Bible is now relatable and no longer a mystery. Thank you !!!`,
    name: 'Shirley Jones'
  },
]

const TheStoryOfTheBiblePage = () => (
  <Layout>

  <SEO title="Book | The Story of the Bible | Beverly Hubbard" keywords={[`beverly hubbard`, `beverly`, `hubbard`, `christian author`, `christian`, `author`, `the story of the bible`, `book writer`, `christian book author`, `books`, `books written`]} />

    <Masthead
      image={<ImgMastheadSOTB/>}
      bottomAccent={<ImgAccentCity/>}
      large={false}
    />

    <BackgroundArmsReachingOut>
      <ImgGraphicArmReachingOut/>
    </BackgroundArmsReachingOut>

    <BackgroundWorld>
      <ImgGraphicTheWorld/>
    </BackgroundWorld>

    <Wrapper>
      <WrapperFill/>
      <Container>
        
        <BookBlock
          title='The Story of the Bible:'
          subtitle="God's Message to the World"
          isbn='ISBN: 978-1-62419-942-4'
          category='All Ages'
          date='December 28th, 2012'
          images={[
            <ImgSOTBFront/>,
            <ImgSOTBBeveled/>,
            <ImgSOTBBack/>,
          ]}
          placeholderImages={[
            <ImgSOTBFrontP/>,
            <ImgSOTBBeveledP/>,
            <ImgSOTBBackP/>,
          ]}
          amazonLink='https://www.amazon.com/Story-Bible-Beverly-Hubbard/dp/1624199429'
        />

        { dataDescription && 
          dataDescription.map((text, i) => (
            <Paragraph1 key={i} innerHTML={text}/>
          ))

        }
        
        <ExcerptsBlock excerpts={dataExcerpts} />

        <MoreResources link='/study-guides/the-story-of-the-bible'/>

      </Container>
    </Wrapper>

    <WrapperReviews>
      <Header2 align={'center'} color={'#FFFFFF'} fontWeight={'200'} spacing={'0'} fontFamily={'News Cycle'} fontSize={'5em'}>REVIEWS</Header2>
    </WrapperReviews>
    
    <GridThree>
      {dataReviews && 
        dataReviews.map((review, i) => (
          <Review
            key={i}
            date={review.date}
            text={review.text}
            name={review.name}
          />
        ))
      }
    </GridThree>

    <WrapperForm>
      <Header1 spacing='0px'>Leave a Review</Header1>
      <FormReview/>
    </WrapperForm>

    <Footer/>
  </Layout>
)

export default TheStoryOfTheBiblePage